import React from 'react'
import ModalConsulta from './ModalConsulta';
import { Tabela } from '../Basicos';

function ModalConsultaProvasPendentes(props) {
    const { estrutura } = props;
    const { provasPendentes } = estrutura?.modal;

    const columns = React.useMemo(
        () => [{
            Header: "Professores",
            style: {
                display: 'none',
            },
            columns: [
                {
                    Header: 'Professor',
                    accessor: 'professor',
                },
                {
                    Header: 'Data Solicitação Conteúdo',
                    accessor: 'data_solicitacao_conteudo',
                },
                {
                    Header: 'Data Limite Envio Questões',
                    accessor: 'data_limite_envio_questoes',
                },
                {
                    Header: 'Data Prova',
                    accessor: 'data_prova',
                },
                {
                    Header: 'Semestre',
                    accessor: 'semestre',
                },
                {
                    Header: 'Título Prova',
                    accessor: 'titulo_prova',
                },
                {
                    Header: 'Dias Expirados',
                    accessor: 'dias_expirados',
                }
            ],
        }],
        []
    )

    return (
        <ModalConsulta
            data={props.data}
            modalClass="modal-map"
            modalBodyClass="modalConsulta"
            size="lg"
            {...props}
        >
            <Tabela
                columns={columns}
                data={provasPendentes}
                tabelaClassName="tabelaConsulta"
            />
        </ModalConsulta>
    );
}

export default ModalConsultaProvasPendentes;
